var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[(_vm.matomoConfigurationExists)?_c('a',{staticClass:"nav-link",attrs:{"href":_vm.matomoLink}},[_vm._v("\n    Matomo\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }